
class TimerQueue {
    private currentTimer: ReturnType<typeof setTimeout> | null = null;
    private tasks: { callback: () => void; delay: number }[] = [];
    private pause = false;

    /**
     * Adds a task to the queue.
     * @param callback - The callback function to execute.
     * @param delay - The delay in milliseconds before executing the callback.
     */
    addTask = (callback: () => void, delay: number): void => {
        this.tasks.push({ callback, delay });
        // If there's a scheduled task, bail out.
        if (this.currentTimer) return;
        // Otherwise, start kicking tires
        this.launchNextTask();
    };

    /**
     * Launches the next task in the queue.
     */
    launchNextTask = (): void => {
        // If there's a scheduled task, bail out.
        if (this.currentTimer) return;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        const nextTask = this.tasks.shift();
        // There's no more tasks, clean up.
        if (!nextTask) return this.clear();
        // Otherwise, schedule the next task.
        this.currentTimer = setTimeout(() => {
            if (this.pause) {
                this.tasks.push({
                    callback: nextTask.callback,
                    delay: nextTask.delay * 2
                });
            } else {
                nextTask.callback();
            }
            self.currentTimer = null;
            // Call this function again to set up the next task.
            self.launchNextTask();
        }, nextTask.delay);
    };

    /**
     * Clears the current timer and task queue.
     */
    clear = (): void => {
        if (this.currentTimer) clearTimeout(this.currentTimer);
        // Timer clears only destroy the timer. It doesn't null references.
        this.currentTimer = null;
        // Fast way to clear the task queue
        this.tasks.length = 0;
    };

    /**
     * Sets the pause state of the queue.
     * @param pause - The pause state.
     */
    setPause = (pause: boolean): void => {
        if (this.pause && !pause) {
            this.launchNextTask();
        }
        this.pause = pause;
    };
}

export default TimerQueue;